import './ccf-skill-control-icon.module.scss';
import { SvgIcon , SvgIconProps} from '@mui/material';
/* eslint-disable-next-line */
export interface CcfSkillControlIconProps extends SvgIconProps  {}
/**
 * Component used to display  align center Icon
 * @param props - CcfAcdIconProps
 * @example - <CcfSkillControlIcon />
 * @returns SVG of align center Icon
 */
export function CcfSkillControlIcon(props: CcfSkillControlIconProps) {
  return (
    <SvgIcon {...props}>
      <path
        d="M4 4.2V1C4 0.4 3.6 0 3 0C2.4 0 2 0.4 2 1V4.2C0.8 4.6 0 5.7 0 7C0 8.3 0.8 9.4 2 9.8V17C2 17.6 2.4 18 3 18C3.6 18 4 17.6 4 17V9.8C5.2 9.4 6 8.3 6 7C6 5.7 5.2 4.6 4 4.2ZM3 8C2.4 8 2 7.6 2 7C2 6.4 2.4 6 3 6C3.6 6 4 6.4 4 7C4 7.6 3.6 8 3 8Z"
        fill="#FF9400"
      />
      <path
        d="M11 9.2V1C11 0.4 10.6 0 10 0C9.4 0 9 0.4 9 1V9.2C7.8 9.6 7 10.7 7 12C7 13.3 7.8 14.4 9 14.8V17C9 17.6 9.4 18 10 18C10.6 18 11 17.6 11 17V14.8C12.2 14.4 13 13.3 13 12C13 10.7 12.2 9.6 11 9.2ZM10 13C9.4 13 9 12.6 9 12C9 11.4 9.4 11 10 11C10.6 11 11 11.4 11 12C11 12.6 10.6 13 10 13Z"
        fill="#FF9400"
      />
      <path
        d="M18 6.2V1C18 0.4 17.6 0 17 0C16.4 0 16 0.4 16 1V6.2C14.8 6.6 14 7.7 14 9C14 10.3 14.8 11.4 16 11.8V17C16 17.6 16.4 18 17 18C17.6 18 18 17.6 18 17V11.8C19.2 11.4 20 10.3 20 9C20 7.7 19.2 6.6 18 6.2ZM17 10C16.4 10 16 9.6 16 9C16 8.4 16.4 8 17 8C17.6 8 18 8.4 18 9C18 9.6 17.6 10 17 10Z"
        fill="#FF9400"
      />
    </SvgIcon>
  );
}

export default CcfSkillControlIcon;
